import { FACILITY_AND_ANCILLARY_ACTIONS } from 'config';

//PAYER LIST ACTIONS
export function requestPayerList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PAYER_LIST,
    payload
  };
}
export function setPayerList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_PAYER_LIST,
    payload
  };
}
export function setPayerListError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_PAYER_LIST_ERROR,
    payload
  };
}

// PAYER PROC LIST COUNT
export function requestPayerProcCount(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PAYER_PROC_COUNT,
    payload
  };
}
export function setPayerProcCountList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_PAYER_PROC_COUNT,
    payload
  };
}
export function setPayerProcCountListError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_PAYER_PROC_COUNT_ERROR,
    payload
  };
}

//CATEGORY LIST ACTIONS
export function requestCategoryList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_CATEGORY_LIST,
    payload
  };
}
export function setCategoryList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_CATEGORY_LIST,
    payload
  };
}
export function setCategoryListError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_CATEGORY_LIST_ERROR,
    payload
  };
}

/*HOSPITAL LIST ACTIONS*/
export function requestHospitalList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_HOSPITAL_LIST,
    payload
  };
}
export function setHospitalList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_HOSPITAL_LIST,
    payload
  };
}
export function setHospitalListError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_HOSPITAL_LIST_ERROR,
    payload
  };
}

/*ANCILLARY LIST ACTIONS*/
export function requestAncillaryList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_ANCILLARY_LIST,
    payload
  };
}
export function setAncillaryList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_ANCILLARY_LIST,
    payload
  };
}
export function setAncillaryListError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_ANCILLARY_LIST_ERROR,
    payload
  };
}

/*PROCEDURE CATEGORY ACTIONS*/
export function requestProcedureCategory(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PROCEDURE_CATEGORY,
    payload
  };
}
export function setProcedureCategory(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_PROCEDURE_CATEGORY,
    payload
  };
}
export function setProcedureCategoryError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_PROCEDURE_CATEGORY_ERROR,
    payload
  };
}

/*NPI LIST ACTIONS*/
export function requestNpiList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_NPI_LIST,
    payload
  };
}
export function setNpiList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_NPI_LIST,
    payload
  };
}
export function setNpiListError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_NPI_LIST_ERROR,
    payload
  };
}

/*BILLING CODE TYPE LIST ACTIONS*/
export function requestBillingCodeTypeList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_BILLING_CODE_TYPE_LIST,
    payload
  };
}
export function setBillingCodeTypeList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_BILLING_CODE_TYPE_LIST,
    payload
  };
}
export function setBillingCodeTypeListError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_BILLING_CODE_TYPE_LIST_ERROR,
    payload
  };
}

/*LEVEL1 DESCRIPTION LIST ACTIONS*/
export function requestLevel1DescList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_L1_DESCRIPTION,
    payload
  };
}
export function setLevel1DescList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_L1_DESCRIPTION,
    payload
  };
}
export function setLevel1DescListError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_L1_DESCRIPTION_ERROR,
    payload
  };
}

/*PROCEDURE NAME LIST ACTIONS*/
export function requestProcedureNameList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PROCEDURE_NAME_LIST,
    payload
  };
}
export function setProcedureNameList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_PROCEDURE_NAME_LIST,
    payload
  };
}
export function setProcedureNameListError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_PROCEDURE_NAME_LIST_ERROR,
    payload
  };
}

/*MODIFIER LIST ACTIONS*/
export function requestModifierList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_MODIFIER_LIST,
    payload
  };
}
export function setModifierList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_MODIFIER_LIST,
    payload
  };
}
export function setModifierListError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_MODIFIER_LIST_ERROR,
    payload
  };
}

/*PAYER PRICE DIFF LIST ACTIONS*/
export function requestPayerPriceDiffList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PAYER_PRICE_DIFF_LIST,
    payload
  };
}
export function setPayerPriceDiffList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_PAYER_PRICE_DIFF_LIST,
    payload
  };
}
export function setPayerPriceDiffListError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_PAYER_PRICE_DIFF_LIST_ERROR,
    payload
  };
}
//Filtered DRG list

export function resetFilteredDRGListFilterState(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.RESET_FILTERED_DRG_LIST_FILTER_STATE,
    payload
  };
}

export function requestFilterDRGHospitalList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRGHOSPITAL_LIST,
    payload
  };
}
export function setFilterDRGHospitalList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_DRGHOSPITAL_LIST,
    payload
  };
}
export function setFilterDRGHospitalListError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_DRGHOSPITAL_LIST_ERROR,
    payload
  };
}

export function requestFilterDRGAncillaryList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRG_ANCILLARY_LIST,
    payload
  };
}
export function setFilterDRGAncillaryList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_ANCILLARY_LIST,
    payload
  };
}
export function setFilterDRGAncillaryListError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_ANCILLARY_LIST_ERROR,
    payload
  };
}

/*RESET PAYER PRICE COMP LIST ACTIONS*/
export function resetPayerPriceCompList() {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.RESET_PAYER_PRICE_COMP_LIST
  };
}

/*RESET FILTERED DRG LIST ACTIONS*/
export function resetFilteredDrgList() {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.RESET_FILTERED_DRG_LIST
  };
}

/*RESET FILTER STATE ACTIONS*/
export function resetFilterState(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.RESET_FILTER_STATE,
    payload
  };
}
export function requestFilterDRGPayerList(payload) {
  console.log('payload', payload);
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRGPAYER_LIST,
    payload
  };
}
export function setFilterDRGPayerList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_DRGPAYER_LIST,
    payload
  };
}
export function setFilterDRGPayerListError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_DRGPAYER_LIST_ERROR,
    payload
  };
}

export function requestFilterDRGBillingCodeType(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRGBILLING_CODE_TYPE,
    payload
  };
}
export function setFilterDRGBillingCodeType(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_DRGBILLING_CODE_TYPE,
    payload
  };
}
export function setFilterDRGBillingCodeTypeError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_DRGBILLING_CODE_TYPE_ERROR,
    payload
  };
}

export function requestFilterDRGBillingCodes(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRGBILLING_CODES,
    payload
  };
}
export function setFilterDRGBillingCodes(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_DRGBILLING_CODES,
    payload
  };
}
export function setFilterDRGBillingCodesError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_DRGBILLING_CODES_ERROR,
    payload
  };
}

export function requestFilterDRGListData(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRGLIST_DATA,
    payload
  };
}
export function setFilterDRGListData(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_DRGLIST_DATA,
    payload
  };
}
export function setFilterDRGListDataError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_DRGLIST_DATA_ERROR,
    payload
  };
}

//DRG COST BREAKDOWN

export function resetDRGCostFilterState(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.RESET_DRG_COST_FILTER_STATE,
    payload
  };
}

export function requestDRGCostAllEntity(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRG_COST_ALLENTITY,
    payload
  };
}
export function setDRGCostAllEntity(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_COST_ALLENTITY,
    payload
  };
}
export function setDRGCostAllEntityError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_COST_ALLENTITY_ERROR,
    payload
  };
}

export function requestDRGProviderName(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRG_PROVIDER_NAME,
    payload
  };
}
export function setDRGProviderName(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_PROVIDER_NAME,
    payload
  };
}
export function setDRGProviderNameError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_PROVIDER_NAME_ERROR,
    payload
  };
}
export function requestDRGCodeCategory(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRG_CODE_CATEGORY,
    payload
  };
}
export function setDRGCodeCategory(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_CODE_CATEGORY,
    payload
  };
}
export function setDRGCodeCategoryError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_CODE_CATEGORY_ERROR,
    payload
  };
}
export function requestDRGReportingEntityName(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRG_REPORTING_ENTITY_NAME,
    payload
  };
}
export function setDRGReportingEntityName(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_REPORTING_ENTITY_NAME,
    payload
  };
}
export function setDRGReportingEntityNameError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_REPORTING_ENTITY_NAME_ERROR,
    payload
  };
}
export function requestDRGBreakdown(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_DRG_BREAKDOWN,
    payload
  };
}
export function setDRGBreakdown(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_BREAKDOWN,
    payload
  };
}
export function setDRGBreakdownError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_DRG_BREAKDOWN_ERROR,
    payload
  };
}

/*STATE MAP DATA LIST ACTIONS*/
export function requestStateMapDataList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_STATE_MAP_DATA_LIST,
    payload
  };
}
export function setStateMapDataList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_STATE_MAP_DATA_LIST,
    payload
  };
}
export function setStateMapDataListError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_STATE_MAP_DATA_LIST_ERROR,
    payload
  };
}

/*SET SELECTED STATE ACTIONS*/
export function setSelectedState(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_SELECTED_STATE,
    payload
  };
}

/*REGIONAL MAP DATA LIST ACTIONS*/
export function requestRegionalMapDataList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_REGIONAL_MAP_DATA_LIST,
    payload
  };
}
export function setRegionalMapDataList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_REGIONAL_MAP_DATA_LIST,
    payload
  };
}
export function setRegionalMapDataListError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_REGIONAL_MAP_DATA_LIST_ERROR,
    payload
  };
}

/*TOP PREF ENTITY LIST ACTIONS*/
export function requestTopPrefEntityList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_TOP_PREF_ENTITY_LIST,
    payload
  };
}
export function setTopPrefEntityList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_TOP_PREF_ENTITY_LIST,
    payload
  };
}
export function setTopPrefEntityListError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_TOP_PREF_ENTITY_LIST_ERROR,
    payload
  };
}

/*OVERVIEW CPT LIST ACTIONS*/
export function requestOverviewCptList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_OVERVIEW_CPT_LIST,
    payload
  };
}
export function setOverviewCptList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_OVERVIEW_CPT_LIST,
    payload
  };
}
export function setOverviewCptListError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_OVERVIEW_CPT_LIST_ERROR,
    payload
  };
}

/*OVERVIEW DRG LIST ACTIONS*/
export function requestOverviewDrgList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_OVERVIEW_DRG_LIST,
    payload
  };
}
export function setOverviewDrgList(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_OVERVIEW_DRG_LIST,
    payload
  };
}
export function setOverviewDrgListError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_OVERVIEW_DRG_LIST_ERROR,
    payload
  };
}

/*TOP PROCEDURE L4 ACTIONS*/
export function requestTopProcedureL4(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_TOP_PROCEDURE_L4,
    payload
  };
}
export function setTopProcedureL4(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_TOP_PROCEDURE_L4,
    payload
  };
}
export function setTopProcedureL4Error(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_TOP_PROCEDURE_L4_ERROR,
    payload
  };
}

/*TOP PROCEDURE NON PREF L4 ACTIONS*/
export function requestTopProcedureNonPrefL4(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_TOP_PROCEDURE_NON_PREF_L4,
    payload
  };
}
export function setTopProcedureNonPrefL4(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_TOP_PROCEDURE_NON_PREF_L4,
    payload
  };
}
export function setTopProcedureNonPrefL4Error(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_TOP_PROCEDURE_NON_PREF_L4_ERROR,
    payload
  };
}

/*HISTORICAL REQUESTS ACTIONS*/
export function requestHistoricalRequests(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_HISTORICAL_REQUESTS,
    payload
  };
}
export function setHistoricalRequests(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_HISTORICAL_REQUESTS,
    payload
  };
}
export function setHistoricalRequestsError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_HISTORICAL_REQUESTS_ERROR,
    payload
  };
}

/*PLACE RE REQUEST ACTIONS*/
export function requestPlaceReRequest(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PLACE_RE_REQUEST,
    payload
  };
}
export function setPlaceReRequest(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_PLACE_RE_REQUEST,
    payload
  };
}
export function setPlaceReRequestError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_PLACE_RE_REQUEST_ERROR,
    payload
  };
}

/*FACILITY SCORECARD SCORES ACTIONS*/
export function requestFacilityScorecardScores(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_FACILITY_SCORECARD_SCORES,
    payload
  };
}
export function setFacilityScorecardScores(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_FACILITY_SCORECARD_SCORES,
    payload
  };
}
export function setFacilityScorecardScoresError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_FACILITY_SCORECARD_SCORES_ERROR,
    payload
  };
}

/*FACILITY SCORECARD NPIS ACTIONS*/
export function requestFacilityScorecardNpis(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_FACILITY_SCORECARD_NPIS,
    payload
  };
}
export function setFacilityScorecardNpis(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_FACILITY_SCORECARD_NPIS,
    payload
  };
}
export function setFacilityScorecardNpisError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_FACILITY_SCORECARD_NPIS_ERROR,
    payload
  };
}

/*PROVIDERS EXTRACT FILTERS ACTIONS*/
export function requestProviderExtractFilters(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PROVIDERS_EXTRACT_FILTERS,
    payload
  };
}
export function setProviderExtractFilters(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_PROVIDERS_EXTRACT_FILTERS,
    payload
  };
}
export function setProviderExtractFiltersError(payload) {
  console.log('payload', payload);
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_PROVIDERS_EXTRACT_FILTERS_ERROR,
    payload
  };
}

/*RESET PROVIDERS EXTRACT RESULT ACTIONS*/
export function resetProvidersExtractResult(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.RESET_PROVIDERS_EXTRACT_RESULT,
    payload
  };
}

/*RESET PROVIDERS EXTRACT CHART RESULT ACTIONS*/
export function resetProvidersExtractChartResult(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.RESET_PROVIDERS_EXTRACT_CHART_RESULT,
    payload
  };
}

/*PROVIDERS EXTRACT RESULT ACTIONS*/
export function requestProviderExtractResult(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PROVIDERS_EXTRACT_RESULT,
    payload
  };
}
export function setProviderExtractResult(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_PROVIDERS_EXTRACT_RESULT,
    payload
  };
}
export function setProviderExtractResultError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_PROVIDERS_EXTRACT_RESULT_ERROR,
    payload
  };
}

/*PROVIDERS EXTRACT RESULT CHARTS ACTIONS*/
export function requestProviderExtractResultCharts(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.REQUEST_PROVIDERS_EXTRACT_RESULT_CHARTS,
    payload
  };
}
export function setProviderExtractResultCharts(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_PROVIDERS_EXTRACT_RESULT_CHARTS,
    payload
  };
}
export function setProviderExtractResultChartsError(payload) {
  return {
    type: FACILITY_AND_ANCILLARY_ACTIONS.SET_PROVIDERS_EXTRACT_RESULT_CHARTS_ERROR,
    payload
  };
}
